import React from 'react'
import { CallbackOnPipe, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import {
  CloseModalOnPipe,
  Form,
  OpenModalOnPipe, SubmitFormOnPipe,
  TriggerPipelineOnFormStartSubmit
} from '@morningtrain/react-resources'
import Modal from 'widgets/modals/Modal'
import { Pipeline } from '@morningtrain/react-pipelines'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'

export default function GetExtraFormDataPipes ({ children, submitButton = null }) {
  const modalRef = React.useRef()

  const _resolve = React.useRef()
  const _reject = React.useRef()

  const handleOnSubmit = (data) => {
    if (_resolve.current !== null) {
      _resolve.current(data)
    }
  }

  const handleClose = (err) => {
    if (_reject.current !== null) {
      _reject.current(err)
    }
  }

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      _resolve.current = data => {
        payload.data = data
        resolve(data)
      }
      _reject.current = (err) => {
        reject(err)
      }
    })
  }

  return (
    <>
      <Modal ref={modalRef} handleClose={handleClose}>
        <Form withoutOperation>
          <Pipeline>
            <TriggerPipelineOnFormStartSubmit />
            <CallbackOnPipe callback={p => {
              handleOnSubmit(p.data)
            }}
            />
          </Pipeline>
          <div className='py-4'>
            {children}
          </div>
          <UI.ButtonWrap className='my-4 mx-1' leftAlign>
            <Pipeline>
              <TriggerPipelineOnClick>
                <UI.Button color='outlineDark'>
                  <Translation name='generic.cancel' />
                </UI.Button>
              </TriggerPipelineOnClick>
              <CloseModalOnPipe modalRef={modalRef} />
            </Pipeline>
            <Pipeline>
              <TriggerPipelineOnClick>
                {submitButton}
              </TriggerPipelineOnClick>
              <SubmitFormOnPipe />
            </Pipeline>
          </UI.ButtonWrap>
        </Form>
      </Modal>
      <OpenModalOnPipe modalRef={modalRef} />
      <CallbackOnPipe callback={handleOnPipe} />
      <CloseModalOnPipe modalRef={modalRef} />
    </>
  )
}
